import "./Spinner.scss";

import type { HTMLAttributes } from "react";

import { AriaLabel } from "../../../types/enums/ariaLabels";

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  /** Size: small, medium, large */
  size?: "sm" | "md" | "lg";
}

export function Spinner({ size = "md", className = "", ...props }: SpinnerProps) {
  const classes = ["shared-spinner", `shared-spinner--${size}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={classes}
      role="status"
      aria-label={AriaLabel.Loading}
      {...props}
    >
      <span className="shared-spinner__circle" aria-hidden />
    </div>
  );
}
